export type Message = { kind: 'ok' | 'error'; text: string } | null;

export const CATEGORIES = [
  'birth_certificate',
  'id_proof',
  'address_proof',
  'transfer_certificate',
  'medical',
  'photo',
  'qualification',
  'contract',
  'other',
] as const;

export const CERT_TYPES = ['bonafide', 'character', 'transfer', 'fee_clearance'] as const;
export type CertType = (typeof CERT_TYPES)[number];

export interface DocumentRow {
  id: string;
  ownerType: 'student' | 'staff';
  studentName: string | null;
  staffName: string | null;
  category: (typeof CATEGORIES)[number];
  title: string;
  originalName: string;
  mimeType: string;
  sizeBytes: number;
  status: 'pending' | 'verified' | 'rejected';
  reviewNote: string | null;
  visibleToParents: boolean;
  createdAt: string;
}

export interface CertificateRow {
  id: string;
  type: CertType;
  studentName: string;
  certificateNumber: string;
  verificationCode: string;
  issueDate: string;
  purpose: string | null;
  status: 'issued' | 'revoked';
  revokeReason: string | null;
}

export interface RequestRow {
  id: string;
  type: CertType;
  studentName: string;
  purpose: string;
  status: 'pending' | 'approved' | 'rejected' | 'cancelled';
  decisionNote: string | null;
  certificateId: string | null;
  createdAt: string;
}

export interface Person {
  id: string;
  firstName: string;
  lastName: string;
  admissionNumber?: string;
  employeeNumber?: string;
}
